var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceSettingTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    display: "inline",
    strokeWidth: 0.264579,
    strokeMiterlimit: 4,
    strokeDasharray: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.105 291.479-.173.023-1.893.267.443.444-2.1 2.101.888.887 2.1-2.101.442.443zm-.312.31-.168 1.191-.256-.253-2.1 2.1-.513-.513 2.101-2.101-.255-.256z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.003 -1098.539) scale(3.77959)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.113 294.604-.185.187.093.094.678.677.094.094.186-.187-.092-.094-.68-.678zM11.648 295.07l-.187.188.094.094.677.677.094.094.188-.188-.094-.093-.678-.678zM11.182 295.537l-.188.186.094.093.678.678.093.094.188-.186-.094-.093-.678-.68z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.003 -1098.539) scale(3.77959)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.326 294.182c-.667 0-1.21.543-1.21 1.21 0 .668.543 1.212 1.21 1.212.667 0 1.211-.544 1.211-1.211 0-.668-.544-1.211-1.21-1.211zm0 .263c.524 0 .945.423.945.948a.943.943 0 0 1-.945.945.946.946 0 1 1 0-1.893z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.003 -1098.539) scale(3.77959)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "fill markers stroke",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.424 14.994v.738h-1.211v2.688h2.414v.693H56.213v1.004H57.424v.731h.998v-.731h1.209v-2.693h-2.412v-.688h2.412v-1.004h-1.209v-.738z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.002)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.191 291.047c-.667 0-1.21.544-1.21 1.21 0 .668.543 1.212 1.21 1.212.668 0 1.211-.544 1.211-1.211s-.543-1.211-1.21-1.211zm0 .264c.525 0 .946.423.946.947a.943.943 0 0 1-.946.945.946.946 0 1 1 0-1.893z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.003 -1098.539) scale(3.77959)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    paintOrder: "fill markers stroke",
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.576 3.146v.739h-1.203v2.687h2.406v.694H44.373V8.27h1.204v.738h1.003V8.27h1.203V5.574H45.37V4.89H47.783V3.885h-1.202v-.739Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    transform: "translate(-40.002)",
    color: "#000000",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: "medium",
    fontFamily: "sans-serif",
    textDecoration: "none",
    letterSpacing: "normal",
    wordSpacing: "normal",
    writingMode: "lr-tb",
    direction: "ltr",
    dominantBaseline: "auto",
    baselineShift: "baseline",
    textAnchor: "start",
    clipRule: "nonzero",
    display: "inline",
    overflow: "visible",
    visibility: "visible",
    opacity: 1,
    colorInterpolation: "sRGB",
    colorInterpolationFilters: "linearRGB",
    vectorEffect: "none",
    fill: "#75b6e1",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1,
    colorRendering: "auto",
    imageRendering: "auto",
    shapeRendering: "auto",
    textRendering: "auto",
    enableBackground: "accumulate",
    stopColor: "#75b6e1",
    stopOpacity: 1,
    className: "fill-000000 stop-color-000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceSettingTool);
export default __webpack_public_path__ + "static/media/price_setting_tool.df01923c084586916635761e9d1c1933.svg";
export { ForwardRef as ReactComponent };